import { PrimitiveBlueprint } from "../types";
import { AVATAR_SIZE_CLASSES } from "./sizeClasses";
import { PRIMITIVE_COLORS } from "../../constants";

const BAT_COLORS = {
  body: PRIMITIVE_COLORS.violet,
  wing: PRIMITIVE_COLORS.darkSlate,
  border: PRIMITIVE_COLORS.darkSlate,
  eye: PRIMITIVE_COLORS.red,
  shadow: PRIMITIVE_COLORS.darkSlate,
};

export const BAT_BLUEPRINT: PrimitiveBlueprint = {
  id: "bat",
  designSize: AVATAR_SIZE_CLASSES.SMALL,
  parts: [
    {
      id: "shadow",
      type: "ellipse",
      bounds: { x: 0.1, y: 0.85, w: 0.8, h: 0.12 },
      style: { fill: BAT_COLORS.shadow, fillAlpha: 0.3 },
      z: 0,
    },
    {
      id: "wing_left",
      type: "triangle",
      bounds: { x: 0.0, y: 0.3, w: 0.3, h: 0.4 },
      style: {
        fill: BAT_COLORS.wing,
        stroke: BAT_COLORS.border,
        strokeWidth: 1.5,
      },
      z: 1,
    },
    {
      id: "wing_right",
      type: "triangle",
      bounds: { x: 0.7, y: 0.3, w: 0.3, h: 0.4 },
      style: {
        fill: BAT_COLORS.wing,
        stroke: BAT_COLORS.border,
        strokeWidth: 1.5,
      },
      z: 1,
    },
    {
      id: "body",
      type: "ellipse",
      bounds: { x: 0.3, y: 0.3, w: 0.4, h: 0.5 },
      style: {
        fill: BAT_COLORS.body,
        stroke: BAT_COLORS.border,
        strokeWidth: 1.5,
      },
      z: 2,
    },
    {
      id: "head",
      type: "ellipse",
      bounds: { x: 0.35, y: 0.15, w: 0.3, h: 0.35 },
      style: {
        fill: BAT_COLORS.body,
        stroke: BAT_COLORS.border,
        strokeWidth: 1.5,
      },
      z: 3,
    },
    {
      id: "ear_left",
      type: "triangle",
      bounds: { x: 0.32, y: 0.05, w: 0.1, h: 0.15 },
      style: {
        fill: BAT_COLORS.body,
        stroke: BAT_COLORS.border,
        strokeWidth: 1.5,
      },
      z: 2,
    },
    {
      id: "ear_right",
      type: "triangle",
      bounds: { x: 0.55, y: 0.05, w: 0.1, h: 0.15 },
      style: {
        fill: BAT_COLORS.body,
        stroke: BAT_COLORS.border,
        strokeWidth: 1.5,
      },
      z: 2,
    },
    {
      id: "eye_left",
      type: "ellipse",
      bounds: { x: 0.4, y: 0.25, w: 0.08, h: 0.1 },
      style: { fill: BAT_COLORS.eye },
      z: 4,
    },
    {
      id: "eye_right",
      type: "ellipse",
      bounds: { x: 0.52, y: 0.25, w: 0.08, h: 0.1 },
      style: { fill: BAT_COLORS.eye },
      z: 4,
    },
  ],
};
